<template>
  <IconLucideCrown />
</template>
